import React from 'react';
import { useState, useEffect } from "react";
import { useHistory, useParams } from 'react-router-dom';
import { ReactComponent as BaseCorp } from "../../../../myfin_v2/assets/icons/companylogo.svg";
import { ReactComponent as CardEditIcon } from "../../../../myfin_v2/assets/icons/editCard.svg";
import { ReactComponent as CloseSideModel } from "../../../../myfin_v2/assets/icons/closeSideModel.svg";
import { ReactComponent as CategoryRightArrow } from "../../../../myfin_v2/assets/icons/categoryRightArrow.svg";
import { ReactComponent as AddCategoryBtn } from "../../../../myfin_v2/assets/icons/addCategoryBtn.svg";
import { ReactComponent as CreateNewCategoryBtn } from "../../../../myfin_v2/assets/icons/createNewCategoryBtn.svg";
import { ReactComponent as CreateNewStageBtn } from "../../../../myfin_v2/assets/icons/createNewStageBtn.svg";
import { ReactComponent as ActiveRadioBtn }  from '../../../../myfin_v2/assets/icons/activeRadioBtn.svg'
import { ReactComponent as InactiveRadioBtn }  from '../../../../myfin_v2/assets/icons/inactiveRadioBtn.svg'
import { ReactComponent as AdSubCategoryBtn }  from '../../../../myfin_v2/assets/icons/adSubCategoryBtn.svg'

import sidemenucss from "../../../css/sidemenu.module.css"
import commoncss from "../../../css/common.module.css";
import DefinitionsCss from "../../../css/definitions.module.css"

import Breadcrumb from "../../../components/Breadcrumb";
import CompanyEditSideMenu from "../CompanyEditSideMenu"

import HeaderWhenSecondSideBarActive from "../../../elements/HeaderWhenSecondSideBarActive"
import { Description } from "@material-ui/icons";

import Select from 'react-select';

import { getAllStaging, createNewStaging, updateStaging, deleteStaging, getAllCategory, createNewCategory, updateCategory, deleteCategory
    //  createNewStaging
     } from "../../../../Bookclosure/Services/ApiHandler"

import swal from "sweetalert";
import { toast } from "react-toastify";

import Modal from "../../../elements/Modal";
import modalcss from "../../../css/modal.module.css";
import { Button } from "../../../elements/Button";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import buttoncss from "../../../css/button.module.css";

const Definitions = () => {

    const [stagingData, setStagingData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    
    const { companyId } = useParams();
    const [companyID, setCompanyID] = useState(companyId);  // Example company ID
    // const [companyID, setCompanyID] = useState('6655b5365ce609ea146c5c53');  // Example company ID
    const [createOrUpdate, setCreateOrUpdate] = useState('C');  // Example state for create or update
    
    useEffect(() => {
        fetchDefinitionsStagingData(companyID, setStagingData);
        fetchDefinitionsCategoryData(companyID, setCategoryData);
    },
    [companyID]);

    const fetchDefinitionsStagingData = async (companyID, setStagingData) => {
        try {
            const response = await getAllStaging(companyID);
            const stagingDt = response.data.stageList;
            setStagingData(stagingDt);

            // console.log('stagingData :: ',stagingData)
        } catch (err) {
            console.error("Failed to fetch data", err);
        }
    };

    const fetchDefinitionsCategoryData = async (companyID, setCategoryData) => {
        try {
            // const response = await getAllCategory(companyID);
            // const cateGoryDt = response.data.categoryList;
            // setCategoryData(cateGoryDt);

            const response = await getAllCategory(companyID);
                const cateGoryDt = response.data.categoryList;
                setCategoryData(cateGoryDt);

        } catch (err) {
            console.error("Failed to fetch data", err);
        }
    };

    const [companyName, setcompanyName] = useState('');  // company name

    const breadcrumbItems = [
        {
            label: "My companies",
            link: `/myfinV2/my-companies`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: companyName,
            link: `/myfinV2/company-details/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        // {
        //     label: "Definitions",
        //     link: `/myfinV2/definitions/${companyID}`,
        //     className: `${commoncss.nav_cnt_color} clickable`,
        // },
        {
            label: "Definitions - Loan Register",
            className: `${commoncss.nav_cnt_color} clickable`,
        },
    ];

    const [stagingTabOrCategoryTab, setstagingTabOrCategoryTab] = useState('staging');

    const [activeTab, setActiveTab] = useState('tab1');

    const [createTab, setCreateTab] = useState("I")
    const [stageName, setStageName] = useState('');
    const [definitionMethod, setdefinitionMethod] = useState('DPD');
    const [rangeType, setRangeType] = useState('between');
    const [startDay, setStartDay] = useState('');
    const [endDay, setEndDay] = useState('');

    const [categories, setCategories] = useState([
    {
        categoryName: '',
        subCategories: [
        {
            subCategoryName: '',
            subSubCategories: ['']
        },
        {
            subCategoryName: '',
            subSubCategories: []
        }
        ]
    }
    ]);


    // ================

    function resetCreateModel(stageOrcategory) {
    if (stageOrcategory === 'category') {
        setCategories([
        {
            categoryName: '',
            subCategories: [
            { subCategoryName: '', subSubCategories: [''] },
            { subCategoryName: '', subSubCategories: [] }
            ]
        }
        ]);
    }

    if (stageOrcategory === 'staging') {
        setStageName('');
        setdefinitionMethod('DPD');
        setRangeType('between');
        setStartDay('');
        setEndDay('');
    }
    }


    return (
        <div className={`${DefinitionsCss.subContainer}`}>
            <CompanyEditSideMenu activeTab={'Definitions'}
                companyID={companyID}
                companyDataCheck={true}
                setcompanyName={setcompanyName}
                subMenuItem={'Loan Register'}
            />

            <div className={DefinitionsCss.subContainer__}>
                <div className={DefinitionsCss.headerWrapper}>
                    <Breadcrumb
                        addCls="bgTransprent"
                        items={breadcrumbItems}
                        headerActions={<></>}
                        p0={true}
                    />
                    <div>
                        <button type="button" className={`${DefinitionsCss.createStagingBtn} ${ createTab === 'A' ? DefinitionsCss.disableCreateBtn : ''}`}
                            disabled={createTab === 'A'}
                            onClick={() => {
                                if (activeTab === 'tab1') {
                                    setCreateTab('A');
                                    setstagingTabOrCategoryTab('staging'); 
                                    setCreateOrUpdate('C'); 
                                    resetCreateModel('staging');
                                }
                                else if (activeTab === 'tab2') {
                                    setCreateTab('A'); setstagingTabOrCategoryTab('category'); setCreateOrUpdate('C'); resetCreateModel('category');
                                }
                            }}
                        >Create New Scenario</button>
                    </div>
                </div>

                <MulitTabsContainer 
                    stagingData={stagingData} 
                    setStagingData={setStagingData} 
                    companyID={companyID} 
                    categoryData={categoryData}  
                    setCategoryData={setCategoryData}
                    createOrUpdate={createOrUpdate}   // Pass createOrUpdate
                    setCreateOrUpdate={setCreateOrUpdate}

                    // ===========
                    resetCreateModel={resetCreateModel}
                    stageName={stageName}
                    setStageName={setStageName}
                    definitionMethod={definitionMethod}
                    setdefinitionMethod={setdefinitionMethod}
                    rangeType={rangeType}
                    setRangeType={setRangeType}
                    startDay={startDay}
                    setStartDay={setStartDay}
                    endDay={endDay}
                    setEndDay={setEndDay}
                    categories={categories}
                    setCategories={setCategories}
                    createTab={createTab} 
                    setCreateTab={setCreateTab}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    stagingTabOrCategoryTab={stagingTabOrCategoryTab}
                    setstagingTabOrCategoryTab={setstagingTabOrCategoryTab}
                />
            </div>
            
        </div>
    );
};

export default Definitions;


const MulitTabsContainer = ({
    stagingData,
    categoryData,
    companyID,
    setStagingData,
    setCategoryData,
    createOrUpdate,  // Receive createOrUpdate from the parent
    setCreateOrUpdate,

    // ==========

    resetCreateModel,
    stageName, setStageName,
    definitionMethod, setdefinitionMethod,
    rangeType, setRangeType,
    startDay, setStartDay,
    endDay, setEndDay,
    categories, setCategories,
    createTab, setCreateTab,
    activeTab, setActiveTab,
    stagingTabOrCategoryTab, setstagingTabOrCategoryTab
    }) => {

    const options = [
        { value: 'between', label: 'Between' },
        { value: 'greaterThan', label: 'Greater than' },
        { value: 'lessThan', label: 'Lesser than' },
      ];

    const defaultOption = options[0];
    const [displayModal, setDisplayModal] = useState(false);
         const handleClose = () => {
       setDisplayModal(false);
       
    };
    
    // this is for opening and close side create or update model
    
    // this will have side model for staging or category
    
    // const [selectedOption, setSelectedOption] = React.useState('Between');

    // staging states
    // const [stageName, setStageName] = useState('');
    // const [definitionMethod, setdefinitionMethod] = useState('DPD'); // e.g. 'dpd' or 'manual'
    // const [rangeType, setRangeType] = useState('between'); // e.g. 'Between', 'LesserThan', 'GreaterThan'
    // const [startDay, setStartDay] = useState(0);
    // const [endDay, setEndDay] = useState(0); 

    const [upadteSelectedStage,setupadteSelectedStage] = useState('')

    const [upadteSelectedCategory, setupadteSelectedCategory] = useState('')

    function FilltheStagingInputWithSelectD(stageId){

        setCreateTab('A');
        setstagingTabOrCategoryTab('staging')

        const stage = stagingData.find(item => item._id === stageId);

        if (stage) {
            setStageName(stage.name || '');
            setdefinitionMethod(stage.definitionMethod || '');
            setRangeType(stage.rangeType || 'between');
            setStartDay(stage.startDay || 0);
            setEndDay(stage.endDay || 30);
        }
    }

    // category states
    // default state
    // const [categories, setCategories] = useState([
    //     {
    //         categoryName: '',
    //         subCategories: [
    //             {
    //                 subCategoryName: '',
    //                 subSubCategories: ['']
    //             },

    //             {
    //                 subCategoryName: '',
    //                 subSubCategories: []
    //             }

    //         ]
    //     }
    // ]);

    useEffect(() => {
        if (categoryData.length > 0) {
            const mappedCategories = categoryData.map(cat => ({
                categoryName: cat.name,
                _id: cat._id,
                subCategories: cat.subcategory.map(sub => ({
                    subCategoryName: sub.name,
                    _id: sub._id,
                    subSubCategories: (sub.subcategory || []).map(ss => ss.name)
                }))
            }));

            // setCategories(mappedCategories); //  Now your form has ID info too
        }
    }, [categoryData]);


    const addSubCategory = (catIdx) => {
        const updated = [...categories];
        updated[catIdx].subCategories.push({
            subCategoryName: '',
            subSubCategories: []
        });
        setCategories(updated);
    };


    const addSubSubCategory = (catIdx, subIdx) => {
        const updated = [...categories];
        updated[catIdx].subCategories[subIdx].subSubCategories.push('');
        setCategories(updated);
    };

    // function resetCreateModel(stageOrcategory){
        
    //     // default input formate
    //     if(stageOrcategory == 'category'){
    //         setCategories([
    //             {
    //                 categoryName: '',
    //                 subCategories: [
    //                 {
    //                     subCategoryName: '',
    //                     subSubCategories: ['']
    //                 },

    //                 {
    //                     subCategoryName: '',
    //                     subSubCategories: []
    //                 }

    //                 ]
    //             }
    //         ])
    //     }

    //     // reseting all values
    //     if(stageOrcategory == 'staging'){
    //         setStageName('')
    //         setdefinitionMethod('DPD')
    //         setRangeType('between')
    //         setStartDay('')
    //         setEndDay('')
    //     }

    // }

    function FillTheCategoryInputFieldsWithSelectedCategory(categoryId){
        setCreateTab('A');
        setstagingTabOrCategoryTab('category')

        const categoryDt = categoryData.find(item => item._id === categoryId);

        if(categoryDt){

            // const formatted = {
            //     categoryName: categoryDt.name,
            //     subCategories: categoryDt.subcategory.map(sub => ({
            //     subCategoryName: sub.name,
            //     subSubCategories: sub.subcategory?.map(subsub => subsub.name) || []
            //     }))
            // };

            const formatted = {
                categoryName: categoryDt.name,
                _id: categoryDt._id,
                subCategories: categoryDt.subcategory.map(sub => ({
                    subCategoryName: sub.name,
                    _id: sub._id,
                    subSubCategories: sub.subcategory?.map(subsub => subsub.name) || []
                }))
            };
            setCategories([formatted]);
        }

    }

    const AddUpdateDeleteStage = (createOrUpdate_) => {

            let startDateVal = 0
            let endDateVal = 0

            if(rangeType === 'between'){
                startDateVal = startDay
                endDateVal = endDay
            }
            else if(rangeType === 'lessThan'){
                endDateVal = endDay
            }
            else if(rangeType === 'greaterThan'){
                startDateVal = startDay
            }

            let data = {}
            
            if(definitionMethod === 'manual'){
                data = { 
                            name: stageName,
                            definitionMethod: definitionMethod,
                        };
            }
            else{
                data = { 
                            name: stageName,
                            definitionMethod: definitionMethod,
                            rangeType:rangeType,
                            startDay:parseInt(startDateVal),
                            endDay:parseInt(endDateVal)
                        };
            }

        if (createOrUpdate_ === 'C') {

            createNewStaging(companyID, data)
            .then(response => {
                toast.success("New Staging Created Successfully.");
                // clear all field (make all fields to empty)
                setStageName('');
                setdefinitionMethod('DPD')
                setStartDay('');
                setEndDay('');
                // fetch all staging and show in the container
                getAllStaging(companyID).then(response => {
                    const staging = response.data.stageList;
                    setStagingData(staging);
                    // setCategoryData(category);
                });
            })
            .catch(error => {
                swal("Error", error.response?.data?.error || "Saving new staging!", 'error');
            });
        }
        else if(createOrUpdate_ === 'U'){

            data['_id'] = upadteSelectedStage

            updateStaging(companyID, data)
            .then(response => {
                toast.success("Staging Updated Successfully.");
                // fetch all staging and show in the container
                getAllStaging(companyID).then(response => {
                    const staging = response.data.stageList;
                    setStagingData(staging);
                    // setCategoryData(category);
                });
            })
            .catch(error => {
                swal("Error", error.response?.data?.error || "Update staging!", 'error');
            });
        }
        else if(createOrUpdate_ === 'D'){

            deleteStaging(companyID,upadteSelectedStage)
            .then(response => {
                toast.success("Deleted Successfully.");
                // closing the side model
                setCreateTab('I')
                // fetch all staging and show in the container
                getAllStaging(companyID).then(response => {
                    const staging = response.data.stageList;
                    setStagingData(staging);
                    // setCategoryData(category);
                });
            })
            .catch(error => {
                swal("Error", error.response?.data?.error || "Delete staging!", 'error');
            });
        }
    };

    // const buildFinalJson = () => {
    //     const result = {
    //         category: categories
    //             .filter(cat => cat.categoryName?.trim()) // Skip empty category names
    //             .map(cat => ({
    //                 // _id: upadteSelectedCategory,
    //                 name: cat.categoryName.trim(),
    //                 subcategory: cat.subCategories
    //                     .filter(sub => sub.subCategoryName?.trim()) // Skip empty subcategory names
    //                     .map(sub => ({
    //                         name: sub.subCategoryName.trim(),
    //                         subcategory: sub.subSubCategories
    //                             .filter(ss => ss?.trim()) // Skip empty sub-subcategory names
    //                             .map(ss => ({
    //                                 name: ss.trim()
    //                             }))
    //                     }))
    //             }))
    //     };

    //     return result.category[0]; // or send whole array if needed
    // };
;


const buildFinalJson = () => {
  const result = {
    category: categories
      .filter(cat => cat.categoryName?.trim()) // Skip empty categories
      .map(cat => {
        const catData = {
          name: cat.categoryName.trim(),
          subcategory: cat.subCategories
            .filter(sub => sub.subCategoryName?.trim()) // Skip empty subcategories
            .map(sub => {
              const subData = {
                name: sub.subCategoryName.trim(),
                subcategory: sub.subSubCategories
                  .filter(ss => ss?.trim()) // Skip empty sub-subcategories
                  .map(ss => ({ name: ss.trim() }))
              };

              if (sub._id) subData._id = sub._id; // add _id only if it exists
              return subData;
            })
        };

        if (cat._id) catData._id = cat._id; // add category _id only if it exists
        return catData;
      })
  };

  console.log('Filtered JSON:', result);
  return result.category[0]; // or return full list if needed
};


const getCategoryDataSendToApi = (
        createOrUpdate_,
    ) => {
        // Create category
        if (createOrUpdate_ === 'C') {

            const finalData = buildFinalJson();

            createNewCategory(companyID, finalData)

             .then(response => {
                
                toast.success("Category Created Successfully.");
                getAllCategory(companyID).then(response => {
                    const categoryDt = response.data.categoryList;
                    setCategoryData(categoryDt);
                });

                // making category fields to empty 
                setCategories([
                    {
                        categoryName: '',
                        subCategories: [
                        {
                            subCategoryName: '',
                            subSubCategories: ['']
                        },

                        {
                            subCategoryName: '',
                            subSubCategories: []
                        }

                        ]
                    }
                ])

            })
            .catch(error => {
                swal("Error", error.response?.data?.error || "Saving new category!", 'error');
            });

        }
        // update Category
        else if (createOrUpdate_ === 'U') {
            const finalData = buildFinalJson();

            finalData['_id'] = upadteSelectedCategory;
     
            updateCategory(companyID, finalData)
            .then(response => {
                
                toast.success("Updated Category Successfully.");
                getAllCategory(companyID).then(response => {
                    const categoryDt = response.data.categoryList;
                    setCategoryData(categoryDt);
                });

            })
            .catch(error => {
                swal("Error", error.response?.data?.error || "updating category!", 'error');
            });
        }
        else if (createOrUpdate_ === 'D') {

            deleteCategory(companyID, upadteSelectedCategory)
            .then(response => {
                toast.success("Category Deleted Successfully.");
                // closing the side model
                setCreateTab('I')

                getAllCategory(companyID).then(response => {
                    const categoryDt = response.data.categoryList;
                    setCategoryData(categoryDt);
                });
            })
            .catch(error => {
                swal("Error", error.response?.data?.error || "Delete category!", 'error');
            });

        }

    };


    return(
        <div className={DefinitionsCss.subMainContainer}>
            <div className={ createTab == 'A' ? DefinitionsCss.tabContainerSideContainer :DefinitionsCss.tabContainer}> 
                
                <div className={DefinitionsCss.tabsContainer}>
                    <div onClick={ () => {setActiveTab('tab1'); setCreateTab('I')} } className={`${DefinitionsCss.btn} ${ activeTab === 'tab1' ? DefinitionsCss.btnActiveFirst : '' }`}>Define Staging</div>
                    <div onClick={ () => {setActiveTab('tab2'); setCreateTab('I')} } className={`${DefinitionsCss.btn} ${ activeTab === 'tab2' ? DefinitionsCss.btnActiveSecond : '' }`} >Define Category</div>
                </div>
                
                {activeTab === 'tab1' && <div className={DefinitionsCss.tabContantContainer}> 
                    {/* <div className={DefinitionsCss.tabHeaderContainer}>
                        <button onClick={() => {setCreateTab('A'); setstagingTabOrCategoryTab('staging'); setCreateOrUpdate('C'); resetCreateModel('staging');}} className={DefinitionsCss.Btn}>Create New Stage</button>
                    </div> */}

                    <div className={DefinitionsCss.cardsContainer}>

                        {/* Staging card */}

                        <CreateNewStageBtn 
                            className={ createTab == 'A' ? DefinitionsCss.cardContainerSideContainerCreateCard : DefinitionsCss.cardContainerSideContainerCreateCardActiveSide} 
                            onClick={() => {setCreateTab('A'); setstagingTabOrCategoryTab('staging'); setCreateOrUpdate('C'); resetCreateModel('staging');}}
                        />

                        {stagingData.map(stage => (
                            
                            <div className={ `${createTab == 'A' ? DefinitionsCss.cardContainerSideContainer : DefinitionsCss.cardContainerSideContainer}`} key={ stage._id } 
                                onClick={() => {FilltheStagingInputWithSelectD(stage._id); setCreateOrUpdate('U'); setupadteSelectedStage(stage._id); }}>

                                <div className={DefinitionsCss.stageCardHeader}>
                                    <div className={createTab == 'A' ? DefinitionsCss.CardTitleSideContainer : DefinitionsCss.CardTitle}>
                                        { stage.name }
                                    </div>
                                    <div>
                                        <CardEditIcon className={ createTab == 'A' ? DefinitionsCss.editIconSizeSideContainer : DefinitionsCss.editIconSize} />
                                    </div>
                                </div>

                                {stage.definitionMethod === 'DPD' ? 
                                
                                    <div className={ createTab == 'A' ? DefinitionsCss.cardDescSideContainer : DefinitionsCss.stageCardDesc}>
                                        DPD (
                                            {stage.endDay === 0
                                            ? `Greater than ${stage.startDay} Days`
                                            : stage.startDay === 0 && stage.endDay != 0
                                            ? `Equal to ${stage.endDay} Days`
                                            : `${stage.startDay} to ${stage.endDay} Days`}
                                        )
                                    </div>
                                : 
                                    <div className={ createTab == 'A' ? DefinitionsCss.cardDescSideContainer : DefinitionsCss.stageCardDesc}>
                                        Manual
                                    </div>

                                }
                            </div>
                        ))}

                    </div>

                </div>}

                {activeTab === 'tab2' && <div className={DefinitionsCss.tabContantContainer}>
                    {/* <div className={DefinitionsCss.tabHeaderContainer}> 
                        <button onClick={() => { setCreateTab('A'); setstagingTabOrCategoryTab('category'); setCreateOrUpdate('C'); resetCreateModel('category'); }} className={DefinitionsCss.Btn}>Create New Category</button>
                    </div>  */}
                    <div className={DefinitionsCss.cardsContainer}>

                        {/* Category card */}
                        <CreateNewCategoryBtn 
                            className={ createTab == 'A' ? DefinitionsCss.cardContainerSideContainerCreateCard : DefinitionsCss.cardContainerSideContainerCreateCardActiveSide} 
                            onClick={() => { setCreateTab('A'); setstagingTabOrCategoryTab('category'); setCreateOrUpdate('C'); resetCreateModel('category'); }}
                        />

                        {categoryData.map( category =>(

                            <div className={ createTab == 'A' ? DefinitionsCss.cardContainerSideContainer : DefinitionsCss.cardContainer} key={ category._id } 
                                onClick={() => {setupadteSelectedCategory(category._id); FillTheCategoryInputFieldsWithSelectedCategory(category._id); setCreateOrUpdate('U');}}>
                                    
                                <div className={DefinitionsCss.cardHeader}>
                                    <div className={createTab == 'A' ? DefinitionsCss.CardTitleSideContainer : DefinitionsCss.CardTitle}>
                                        { category.name }
                                    </div>
                                    <div>
                                        <CardEditIcon className={ createTab == 'A' ? DefinitionsCss.editIconSizeSideContainer : DefinitionsCss.editIconSize} />
                                    </div>
                                </div>

                                <div className={ createTab == 'A' ? DefinitionsCss.cardDescSideContainer : DefinitionsCss.cardDesc}>
                                    <CategoryRightArrow className={ createTab == 'A' ? DefinitionsCss.editIconSizeSideContainer : DefinitionsCss.editIconSize} />
                                    &nbsp; Sub-category, sub categ.. + {
                                    category.subcategory.reduce((acc, subcat) => 
                                    acc + (subcat.subcategory ? subcat.subcategory.length : 0), 0
                                    )}
                                </div>

                            </div>
                        ) )}


                    </div>
                </div>}

            </div>

            {
                createTab == 'A' ? (
                    <>
                    {
                        stagingTabOrCategoryTab == 'staging' ? (
                            <div className={DefinitionsCss.CreateContainer}>
                                <div className={DefinitionsCss.sideModelHeader}>
                                    <div className={DefinitionsCss.sideModelTitle}>
                                    
                                    {createOrUpdate == 'C' ? 'Create New Stage' : 'Update Stage'}
                                    </div>
                                    <CloseSideModel className={sidemenucss.sideModelCloseIcon} onClick={() => setCreateTab('I')} style={{ cursor : 'pointer' }} />
                                </div>

                                <div className={DefinitionsCss.InptContainer}>
                                    <span className={DefinitionsCss.Inptlabel}>Stage Name</span>
                                    <input className={DefinitionsCss.inpt} type="text" 
                                        value={stageName} placeholder="Enter name" 
                                        onChange={(e) => setStageName(e.target.value)} />
                                    <small className={DefinitionsCss.inptDesc}>
                                    Note or description for particular field
                                    </small>
                                </div>

                                <div className={DefinitionsCss.methodTypeContainer}>  
                                    <div className={DefinitionsCss.methodType}>
                                        Definition Method
                                    </div>
                                    <div className={DefinitionsCss.methodInptContainer}>

                                    <label style={{ marginRight: '35px' }} className={DefinitionsCss.LabelContant} onClick={() => {setdefinitionMethod('DPD');}}>
                                        {/* <div className={DefinitionsCss.customRadioOuter}>
                                            {definitionMethod === 'DPD' ? 
                                                <div className={DefinitionsCss.customRadioInner}></div> : null
                                            }
                                        </div> */}
                                        {definitionMethod === 'DPD' ?  <ActiveRadioBtn className={DefinitionsCss.custuRadioBtn} /> : <InactiveRadioBtn className={DefinitionsCss.custuRadioBtn} />}
                                        Days Past Due (DPD)
                                    </label>

                                    <label className={DefinitionsCss.LabelContant} onClick={() => {setdefinitionMethod('manual')}}>
                                        {/* <div className={DefinitionsCss.customRadioOuter}>
                                            {definitionMethod == 'manual' ? 
                                                <div className={DefinitionsCss.customRadioInner}></div> : null
                                            }
                                        </div> */}
                                        {definitionMethod == 'manual' ?  <ActiveRadioBtn className={DefinitionsCss.custuRadioBtn} /> : <InactiveRadioBtn className={DefinitionsCss.custuRadioBtn} />}
                                        Manual
                                    </label>

                                    </div>
                                </div>

                                { definitionMethod === 'DPD' ?

                                    <React.Fragment>

                                        <div className={DefinitionsCss.rangeInptContainer}>
                                            <div className={DefinitionsCss.rangeContainerLabel}>Range Type</div>
                                            <Select
                                                defaultValue={rangeType === '' ? defaultOption : rangeType}
                                                components={{ IndicatorSeparator: () => null }} // remove separator
                                                options={options}
                                                placeholder="Select Status"
                                                name="status"
                                                className="w-100 mt-0 custom-bg-gray-300"
                                                value={options.find(option => option.value === rangeType)}
                                                onChange={(selectedOption) => {
                                                    setRangeType(selectedOption.value);
                                                    console.log("Selected:", selectedOption.value);
                                                }}
                                                classNamePrefix="select"
                                                styles={customStyles}
                                                isClearable={false}
                                                isSearchable={false}
                                            />

                                        </div>

                                        <div className={DefinitionsCss.rangeInputcontainer}>
                                            {rangeType == 'lessThan' ? '' :   <input value={startDay} className={DefinitionsCss.rangeInptText} type="text" placeholder="Enter Start Day" onChange={(e) => setStartDay(e.target.value)} />}
                                            {rangeType == 'between' ? <span className={DefinitionsCss.rangeInptContainerText}>To</span> : ''}
                                            {rangeType == 'greaterThan' ? '' : <input value={endDay} className={DefinitionsCss.rangeInptText} type="text" placeholder="Enter End Day" onChange={(e) => setEndDay(e.target.value)} />}
                                        </div>
                                    </React.Fragment>

                                :
                                null
                                
                                }


                                <div className={DefinitionsCss.createCanelBtnContainer}>
                                    <div>
                                        <button className={`${DefinitionsCss.cancelStagingBtn}`} type="button" onClick={() => {setCreateTab('I')}}>
                                            Cancel
                                        </button>
                                        
                                        {createOrUpdate === 'U' ? 
                                            <button className={`${DefinitionsCss.delBtn}`} type="button" 
                                                onClick={() => 
                                                // AddUpdateDeleteStage('D')
                                                setDisplayModal(true)

                                            }
                                            >
                                            Delete Stage
                                            </button>

                                        :
                                            null
                                        }
                                    </div>

                                    <button 
                                        className={`${DefinitionsCss.createStagingBtn}`} 
                                        type="button" 
                                        onClick={() => 
                                            AddUpdateDeleteStage(
                                                createOrUpdate,       // 'C' or 'U'
                                            )}
                                    >
                                        {createOrUpdate === 'C' ? 'Create' : 'Update'}
                                    </button>
                                    
                                </div>
                            </div>
                        ) 
                        : 
                        null
                    }

                    {
                        stagingTabOrCategoryTab == 'category' ? 
                        (
                            <div className={DefinitionsCss.CreateContainer}>
                                <div className={DefinitionsCss.sideModelHeader}>
                                    <div className={DefinitionsCss.sideModelTitle}>
                                    
                                        {createOrUpdate == 'C' ? 'Create New Category' : 'Update Category'}

                                    </div>
                                    <CloseSideModel className={sidemenucss.sideModelCloseIcon} onClick={() => setCreateTab('I')} style={{ cursor : 'pointer' }} />
                                </div>

                                    {categories.map((cat, catIdx) => (
                                        <div key={catIdx}>
                                            <div className={DefinitionsCss.InptContainer}>
                                            <div className={DefinitionsCss.inptLabelContainer}>
                                                <span className={DefinitionsCss.Inptlabel}>Category Name</span>
                                                <span
                                                    className={DefinitionsCss.InptActionlabel}
                                                    onClick={() => addSubCategory(catIdx)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                Add Sub Category
                                                </span>
                                            </div>
                                            <input
                                                className={DefinitionsCss.inpt}
                                                type="text"
                                                placeholder="Category Name"
                                                value={cat.categoryName}  // Bind to category name
                                                onChange={(e) => {
                                                    const newCats = [...categories];
                                                newCats[catIdx].categoryName = e.target.value;
                                                    setCategories(newCats);
                                                }}
                                            />
                                            </div>

                                            <div 
                                                className={DefinitionsCss.categoryScrollContainer}
                                                // style={{ overflowY: 'scroll', height: '65vh', marginBottom: '60px' }}
                                            >
                                                {cat.subCategories.map((sub, subIdx) => (
                                                    <div key={subIdx}>
                                                    <div className={DefinitionsCss.InptContainer}>
                                                        <div className={DefinitionsCss.inptLabelContainer}>
                                                        <span className={DefinitionsCss.Inptlabel}>
                                                            <CategoryRightArrow className={DefinitionsCss.editIconSize} />
                                                            &nbsp; Sub - Category Name
                                                        </span>
                                                        <span
                                                            onClick={() => addSubSubCategory(catIdx, subIdx)}
                                                            className={DefinitionsCss.InptActionlabel}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            Add Child Category
                                                        </span>
                                                        </div>
                                                        <div className={DefinitionsCss.subCategoryInptContainer}>
                                                        <input
                                                            className={DefinitionsCss.SubCategoryInpt}
                                                            type="text"
                                                            placeholder="SubCategory Name"
                                                            value={sub.subCategoryName}  // Bind to subcategory name
                                                            onChange={(e) => {
                                                            const newCats = [...categories];
                                                            newCats[catIdx].subCategories[subIdx].subCategoryName = e.target.value;
                                                            setCategories(newCats);
                                                            }}
                                                        />
                                                        </div>
                                                    </div>

                                                    {sub.subSubCategories.map((ss, ssIdx) => (
                                                        <div key={ssIdx} className={DefinitionsCss.InptContainer}>
                                                            <div className={DefinitionsCss.SubSubinptLabelContainer}>
                                                            <span className={DefinitionsCss.SubSubInptlabel}>
                                                                <CategoryRightArrow className={DefinitionsCss.editIconSize} />
                                                                &nbsp; Sub - Sub Category Name
                                                            </span>
                                                            <span className={DefinitionsCss.InptActionlabel}></span>
                                                            </div>
                                                            <div className={DefinitionsCss.subCategoryInptContainer}>
                                                            <input
                                                                className={DefinitionsCss.SubSubCategoryInpt}
                                                                type="text"
                                                                placeholder="Category Name"
                                                                value={ss}
                                                                onChange={(e) => {
                                                                const newCats = [...categories];
                                                                newCats[catIdx].subCategories[subIdx].subSubCategories[ssIdx] = e.target.value;
                                                                setCategories(newCats);
                                                                }}
                                                            />
                                                            </div>
                                                        </div>
                                                        ))}
                                                    </div>
                                                ))}

                                            <AddSubCategoryBtn onClick={() => addSubCategory(catIdx)} />
                                            </div>
                                        </div>
                                        ))}

                                <div className={DefinitionsCss.createCanelBtnContainer}>
                                    <div>
                                        <button className={`${DefinitionsCss.cancelStagingBtn}`} type="button" onClick={() => {setCreateTab('I')}}>
                                            Cancel
                                        </button> 
                                        {createOrUpdate === 'U' ? 
                                            <button className={`${DefinitionsCss.delBtn}`} type="button" 
                                                    onClick={() => getCategoryDataSendToApi('D')}
                                                >
                                                Delete Category
                                            </button>
                                        :
                                        null}
                                    </div>

                                    <button 
                                        className={`${DefinitionsCss.createStagingBtn}`} 
                                        type="button" 
                                        onClick={() => 
                                            getCategoryDataSendToApi(
                                                createOrUpdate,       // 'C' or 'U'
                                            )}
                                    >
                                        {createOrUpdate === 'C' ? 'Create' : 'Update'}
                                    </button>


                                </div>
                            </div>
                        )
                        :
                        null
                    }
                    </>
                ) : null
            }
            {displayModal && (
                                         <Modal
                                          headerActions={
                                            <CloseIcon
                                              onClick={() => {
                                                handleClose();
                                                setDisplayModal(false);
                                              }}
                                              className="clickable"
                                            />
                                          }
                                          headerBottomLine={false}
                                          onClose={() => console.log("Modal Closed")}
                                        >
                                          <span className={`${modalcss.modalDeleteBodyHead}  mb-1`}>
                                            {/* Do you want to <span className="fw700">delete</span> the
                                            company? */}
                                            Are you sure you want to Delete?
                                          </span>
                                          
                                          <span
                                            className={`${modalcss.modalDeleteBodycnt}`}
                                            style={{ "margin-bottom": "35px ","marginTop": "10px","padding":"0px 45px" }}
                                          > 
                                            {/* Once deleted, you cannot restore the company */}
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit.Nam enim  posuere. Aliquam.
                                          </span>
                        
                                          <span
                                            className={`${modalcss.modalDeleteBodycnt} ${modalcss.modalDeleteBodyBtns}`}
                                          >
                                            <Button
                                              btnColor={buttoncss.dangerDeleteModelBtn}
                                              label="Yes, Delete"
                                            //   icon={<DeleteIcon width={20} height={20} />}
                                              onClick={() => {
                                                // deleteCompany();
                                                // sendDataToIRACApi('D'); 
                                                AddUpdateDeleteStage('D');
                                                handleClose();
                                              }}
                                            />
                                            <Button
                                              btnColor={buttoncss.deleteModelBtn_secondary_del}
                                              label="No, Don't"
                                              onClick={() => {
                                                handleClose();
                                                setDisplayModal(false);
                                              }}
                                            />
                                          </span>
                                        </Modal>
                        )}


        </div>

    )

}


const AddSubCategoryBtn = ({ onClick }) =>{
    return(
            <div className={DefinitionsCss.InptContainer} onClick={onClick} style={{ cursor : 'pointer' }}>
                <div className={DefinitionsCss.subCategoryInptContainer}>
                    <div className={DefinitionsCss.AddSubCategoryInptBtn}>
                        <AddCategoryBtn className={DefinitionsCss.editIconSize} /> 
                        &nbsp;
                        &nbsp;
                        Add Sub Category 
                    </div>
                    {/* <AdSubCategoryBtn className={DefinitionsCss.AddSubCategoryInptBtn} /> */}
                </div>
            </div>
        )
}

const AddSubSubCategoryBtn = ({ onClick }) =>{
    return(
            <div className={DefinitionsCss.InptContainer} onClick={onClick} style={{ cursor : 'pointer' }}>
                <div className={DefinitionsCss.subCategoryInptContainer}>
                    <div className={DefinitionsCss.AddSubSubCategoryInptBtn}>
                        <AddCategoryBtn className={DefinitionsCss.editIconSize} /> 
                        &nbsp;
                        &nbsp;
                        Add Sub - Sub Category 
                    </div>
                </div>
            </div>
        )
}

// const customStyles = {
//     control: (base, state) => ({
//         ...base,
//         borderRadius: '12.07px',
//         backgroundColor: '#F4FAF5',
//         border: '1px solid #C2E6D1',
//         color: '#4D6D64',
//         padding: '5.32px 14.49px',
//         boxShadow: 'none',
//         '&:hover': {
//         borderColor: '#C2E6D1',
//         },
//     }),
//     option: (base, state) => ({
//         ...base,
//         backgroundColor: state.isFocused ? '#C2E6D1' : '#FFFFFF',
//         color: '#4D6D64',
//         padding: '12px 16px',
//         cursor: 'pointer',
//         fontWeight: state.isSelected ? 'bold' : 'normal',
//     }),
//     menu: (base) => ({
//         ...base,
//         borderRadius: '12.07px',
//         marginTop: '5px',
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         border: '1px solid #C2E6D1',
//     }),
//     };



// export const customStyles = {
//   control: (provided, state) => ({
//     ...provided,
//     backgroundColor: '#f4faf5',
//     borderColor: '#c2e6d1',
//     color: '#b3c0bd',
//     boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
//     borderWidth: '1px',
//     borderRadius: '0.5rem',
//     '&:hover': {
//       borderColor: '#b3c0bd',
//     },
//     minHeight: '38px',
//     height: '38px'
//   }),
//   valueContainer: (provided) => ({
//     ...provided,
//     padding: '2px 8px',
//     paddingTop: '1px'
//   }),
//   input: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   placeholder: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     fontSize: "14px"
//   }),
//   singleValue: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//     fontSize: "14px"
//   }),
//   multiValue: (provided) => ({
//     ...provided,
//     backgroundColor: '#e0f5e9', // softer variant
//     borderRadius: '0.25rem',
//     border: '1px solid #c2e6d1',
//     width: 'fit-content'
//   }),
//   multiValueLabel: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//   }),
//   multiValueRemove: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       backgroundColor: '#c2e6d1',
//       color: '#4f665f',
//     },
//   }),
//   indicatorsContainer: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   dropdownIndicator: (provided, state) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   clearIndicator: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   menu: (provided) => ({
//     ...provided,
//     backgroundColor: '#f4faf5',
//     border: '1px solid #c2e6d1',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
//     borderRadius: '0.5rem',
//     zIndex: 10,
//   }),
//   menuList: (provided) => ({
//     ...provided,
//     padding: 0,
//   }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? '#c2e6d1'
//       : state.isFocused
//         ? '#e9f7ef'
//         : 'transparent',
//     color: '#4f665f',
//     padding: '10px 12px',
//     cursor: 'pointer',
//     fontSize: "14px"
//   }),
//   noOptionsMessage: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     padding: '8px 12px',
//   }),
// };


export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    borderColor: '#c2e6d1',
    color: '#b3c0bd',
    boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
    borderWidth: '1px',
    borderRadius: '10px',
    '&:hover': {
      borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#4d6d64',
    fontSize: '14px',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9',
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#4d6d64',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#205a46', 
    ':hover': {
        color: '#205a46',
    },
    }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      color: '#4f665f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '10px',
    boxShadow: '0 0 0 1px #c2e6d1',
    marginTop: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '10px',
  }),
option: (provided, state) => ({
  ...provided,
  backgroundColor: state.isFocused
    ? '#f4faf5'
    : 'transparent',
  color: '#4f665f',
  padding: '10px 12px',
  cursor: 'pointer',
  fontSize: '14px',
  borderRadius: '8px',
}),

  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};
